import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useSyncExternalStore } from 'react';
import { TrialExitFeedbackController } from '../trialExitFeedbackController';
import { TrialExitQuestion } from './TrialExitQuestion';
export function useTrialExitFeedback({ accountId, teamId, transport, enabled = true }) {
    const controller = useMemo(() => new TrialExitFeedbackController({ accountId, teamId, transport, enabled }), [accountId, teamId, transport, enabled]);
    const snapshot = useSyncExternalStore(controller.subscribe, controller.getSnapshot, controller.getSnapshot);
    useEffect(() => { controller.activate(); return controller.dispose; }, [controller]);
    const current = snapshot.question;
    const question = current ? _jsx(TrialExitQuestion, { placement: current.placement, onSend: answer => controller.send(current, answer), onSkip: controller.skip, onShown: () => controller.shown(current) }, current.key) : null;
    return { question, offer: controller.offer, skip: controller.skip };
}
//# sourceMappingURL=useTrialExitFeedback.js.map